import ApprovalRunCard from './components/ApprovalRunCard.vue'
import ChangeOriginBlock from './components/ChangeOriginBlock.vue'
import { useApprovalOrigins } from './composables/useApprovalOrigins'
import {
  registerInsightActionEventBus,
  type InsightActionEventBus,
} from './composables/useInsightActionSurface'
import { registerInsightActionSessionReset } from './lifecycle/registerInsightActionSessionReset'
import { setInsightRouteName } from './service/insightLink'

import {
  registerActionDetailBlock,
  registerApprovalInboxGrouping,
} from '@/features/platform-actions'

export interface InsightActionInstallOptions {
  insightRouteName: string
}

export function installInsightActions(
  bus: InsightActionEventBus,
  options: InsightActionInstallOptions,
): void {
  registerInsightActionEventBus(bus)
  registerInsightActionSessionReset()
  setInsightRouteName(options.insightRouteName)
  registerActionDetailBlock({ key: 'insightActions.origin', component: ChangeOriginBlock })
  // F5 (ORP-22267): the approvals page folds one insight run's requests into one card, answered by
  // a single bulk origin lookup for the whole page.
  registerApprovalInboxGrouping({ use: useApprovalOrigins, component: ApprovalRunCard })
}
